import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import selectors from 'state/selectors';
import utils from 'utils';
import Table, { TableColumn } from 'components/Table';
import Modal from 'components/Modal';
import { useDispatch } from 'react-redux';
import { GetAssetHistory } from '../../../../../models/response';
import { useAsync } from 'react-use';
import services from 'services';
import actions from 'state/actions';
import { Row } from 'models/table';
import { useHistory, useRouteMatch } from 'react-router';
const PreviousDocuments = () => {
  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();
  const { dateFormat } = useSelector(selectors.user.getUserPreference);
  const userPreference = useSelector(selectors.user.getUserPreference);
  const documentImageId = useSelector(selectors.documents.selectDocumentImageId);
  const history = useHistory();
  const { path } = useRouteMatch();
  const [rows, setRows] = useState<GetAssetHistory[]>([]);
  const record = useSelector(selectors.documents.selectActiveDocument);
  const protocolActiveDocumentId = useSelector(selectors.documents.selectActiveDocumentID);

  useAsync(async () => {
    if (!record) return;
    const { data } = await services.getAssetDocumentHistory(record.idSubject);
    setRows(data);
  }, [record]);

  const columns: TableColumn[] = [
    {
      accessor: 'subject',
      Header: t('Asset'),
    },
    { accessor: 'company', Header: t('Banner') },
    { accessor: 'mallName', Header: t('mallName') },
    { accessor: 'landlordName', Header: t('landlordName') },
    { accessor: 'documentType', Header: t('documentType') },
    { accessor: 'address', Header: t('address') },
    {
      accessor: 'acquisitionDate',
      Header: t('acquisitionDate'),
      Cell: ({ value }: { value: number }) => utils.date.convertDate(value, userPreference.timeZone ?? 'UTC'),
      filter: utils.date.epochFilterFunction(userPreference.timeZone ?? 'UTC'),
      filterType: 'date',
      dateFormat,
    },
    {
      accessor: 'startDate',
      Header: t('startDate'),
      Cell: ({ value }: { value: number }) => utils.date.convertDate(value, userPreference.timeZone ?? 'UTC'),
      filter: utils.date.epochFilterFunction(userPreference.timeZone ?? 'UTC'),
      filterType: 'date',
      dateFormat,
    },
    {
      accessor: 'expirationDate',
      Header: t('expirationDate'),
      Cell: ({ value }: { value: number }) => utils.date.convertDate(value, userPreference.timeZone ?? 'UTC'),
      filter: utils.date.epochFilterFunction(userPreference.timeZone ?? 'UTC'),
      filterType: 'date',
      dateFormat,
    },
    {
      accessor: 'closingDate',
      Header: t('closingDate'),
      Cell: ({ value }: { value: number }) => utils.date.convertDate(value, userPreference.timeZone ?? 'UTC'),
      filter: utils.date.epochFilterFunction(userPreference.timeZone ?? 'UTC'),
      filterType: 'date',
      dateFormat,
    },
  ];

  const onSelection = (allRows: Row[], selection: Row) => {
    const { protocol } = selection;
    dispatch(actions.documents.setActiveDocumentId([protocol]));
    if (selection.protocol !== documentImageId) {
      dispatch(actions.documents.setDocumentImage(''));
    }
    if (allRows.length === 0) return null;
    const rowIndex = allRows.findIndex((ele) => ele?.original?.id === selection?.id);
    if (rowIndex === -1) return null;
    dispatch(actions.modal.closeModal());
    const newPath = path.endsWith('/edit') ? path : `${path}/edit`;
    history.push({
      pathname: newPath,
      state: {
        fromContractViewPreviousDocModal: true,
        sourceDocumentId: protocolActiveDocumentId,
      },
    });
  };

  return (
    <>
      <Modal.Header title={t('previos_document')} subtitle={t('click_row_to_view_asset')} />
      <Modal.Content>
        <Table
          id="previous-documents-table"
          columns={columns}
          rows={rows}
          hasPagination
          hasSort
          hasFilter
          hasSelection
          onRowDoubleClick={(allRows: Row[], selection: Row) => onSelection(allRows, selection)}
        />
      </Modal.Content>
      <Modal.Footer withConfirmButton={false} closeButtonText={t('cancel')} />
    </>
  );
};

export default PreviousDocuments;
